import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Wrapper = styled.div`
  width: ${({ width }) => `${width}px`};
  position: relative;

  :not(:last-child) {
    margin-right: ${({ marginRight }) => `${marginRight}px`};
  }
`;

export const SlideContainer = styled(motion.div)`
  height: 430px;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  box-shadow: ${({ isColumn }) => (isColumn ? 0 : '0px 8px 32px rgba(15, 23, 42, 0.16)')};
`;

export const CounterWrapper = styled.div`
  display: flex;
  padding: 13px 14px 0 14px;
  width: 100%;
  position: absolute;
  z-index: 2;
`;

export const StoryCounter = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 10px;
  background: ${({ storyIsViewed }) => (storyIsViewed ? '#3BAAAB' : '#2B7D7D')};
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  :not(:last-child) {
    margin-right: 5px;
  }

  > div {
    height: 100%;
    border-radius: 4px;
    background: #3baaab;
  }
`;

export const StoryContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledImage = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  user-drag: none;
  opacity: ${({ isActiveStory }) => (isActiveStory ? 1 : 0)};

  ${({ isColumn }) =>
    isColumn &&
    css`
      position: relative;
      opacity: 1;
      height: 202px;
    `}
`;

export const StyledVideo = styled.video`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  user-drag: none;
  object-fit: cover;
  opacity: ${({ isActiveStory }) => (isActiveStory ? 1 : 0)};
`;

export const YearWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 10px;
  height: 25px;
  color: ${th('colors.black')};

  ::before {
    content: '';
    background-color: #8ad6d7;
    position: absolute;
    height: 1px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    transition: 0.5s;
    transition-delay: 0.3;

    left: ${({ isFirstSlide, marginRight }) => (isFirstSlide ? 0 : `-${marginRight}px`)};
    width: ${({ isActiveSlide, isFirstSlide, marginRight }) => {
      const lineOffset = isActiveSlide ? '50px' : '40px';

      let width = `calc(50% + ${marginRight}px - ${lineOffset})`;

      if (isFirstSlide) {
        width = `calc(50% - ${lineOffset})`;
      }

      return width;
    }};
  }

  ::after {
    content: '';
    position: absolute;
    height: 1px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-color: #8ad6d7;
    transition: 0.5s;
    transition-delay: 0.3;

    right: 0;
    width: ${({ isActiveSlide }) => {
      const lineOffset = isActiveSlide ? '50px' : '40px';

      const width = `calc(50% - ${lineOffset})`;

      return width;
    }};
  }
`;

export const Year = styled.div`
  font-size: ${({ isActiveSlide }) => (isActiveSlide ? '22px' : '16px')};
  opacity: ${({ isActiveSlide }) => (isActiveSlide ? 1 : 0.5)};
  font-weight: bold;
  margin: auto;
  transition: 0.5s;
  transition-delay: 0.3;

  @media ${sizes.tabletLandscape} {
    font-size: ${({ isActiveSlide }) => (isActiveSlide ? '24px' : '18px')};
  }
`;

export const Month = styled.div`
  width: fit-content;
  color: ${th('colors.black')};
  margin: 0px auto;
  font-size: 16px;
  opacity: ${({ isActiveSlide }) => (isActiveSlide ? 1 : 0)};
  transition: 0.5s;
  transition-delay: 0.3;
  margin-bottom: 10px;
`;

export const Description = styled.h3`
  color: ${th('colors.black')};
  line-height: 26px;
  margin-top: 20px;
  margin-bottom: 15px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  opacity: ${({ isActiveSlide }) => (isActiveSlide ? 1 : 0)};
  transition: 0.5s;
  transition-delay: 0.3;

  @media ${sizes.tabletLandscape} {
    font-size: 18px;
  }
`;
